var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768.434 777.86c22.621 0 40.96-18.342 40.96-40.96V205.444c0-22.625-18.335-40.96-40.96-40.96H256.547c-22.625 0-40.96 18.335-40.96 40.96V736.9c0 22.618 18.339 40.96 40.96 40.96h511.887zm0 40.96H256.547c-45.243 0-81.92-36.681-81.92-81.92V205.444c0-45.246 36.674-81.92 81.92-81.92h511.887c45.246 0 81.92 36.674 81.92 81.92V736.9c0 45.239-36.677 81.92-81.92 81.92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M830.414 982.66c45.234 0 81.92-36.686 81.92-81.92V122.879c0-45.241-36.682-81.92-81.92-81.92H194.561c-45.245 0-81.92 36.675-81.92 81.92V900.74c0 45.238 36.679 81.92 81.92 81.92h635.853zm0 40.96H194.561c-67.863 0-122.88-55.021-122.88-122.88V122.879c0-67.866 55.014-122.88 122.88-122.88h635.853c67.859 0 122.88 55.017 122.88 122.88V900.74c0 67.856-55.024 122.88-122.88 122.88z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M534.418 900.74c0-11.309-9.171-20.48-20.48-20.48s-20.48 9.171-20.48 20.48c0 11.309 9.171 20.48 20.48 20.48s20.48-9.171 20.48-20.48zm40.96 0c0 33.931-27.509 61.44-61.44 61.44s-61.44-27.509-61.44-61.44 27.509-61.44 61.44-61.44 61.44 27.509 61.44 61.44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9f7713cd5afa31d1ae657154e82fdd88.svg";
export { ForwardRef as ReactComponent };